import { mergeAttributes, Node } from '@tiptap/core';

const ProxySignature = Node.create({
	name: 'proxy-signature',

	group: 'inline',

	inline: true,

	atom: true,

	addOptions() {
		return {
			t: key => key,
		};
	},
	addAttributes() {
		return {
			image: {
				default: null,
				parseHTML: element => element.getAttribute('data-image'),
				renderHTML: attributes => {
					if (!attributes.image) {
						return {};
					}

					return {
						'data-image': attributes.image,
					};
				},
			},
			signedText: {
				default: null,
				parseHTML: element => element.getAttribute('data-signed-text'),
				renderHTML: attributes => {
					if (!attributes.signedText) {
						return {};
					}

					return {
						'data-signed-text': attributes.signedText,
					};
				},
			},
			username: {
				default: null,
				parseHTML: element => element.getAttribute('data-username'),
				renderHTML: attributes => {
					if (!attributes.username) {
						return {};
					}

					return {
						'data-username': attributes.username,
					};
				},
			},
			medicalCredentials: {
				default: null,
				parseHTML: element => element.getAttribute('data-medical-credentials'),
				renderHTML: attributes => {
					if (!attributes.medicalCredentials) {
						return {};
					}
					return {
						'data-medical-credentials': attributes.medicalCredentials,
					};
				},
			},
			date: {
				default: null,
				parseHTML: element => element.getAttribute('data-date'),
				renderHTML: attributes => {
					if (!attributes.date) {
						return {};
					}

					return {
						'data-date': attributes.date,
					};
				},
			},
			time: {
				default: null,
				parseHTML: element => element.getAttribute('data-time'),
				renderHTML: attributes => {
					if (!attributes.time) {
						return {};
					}

					return {
						'data-time': attributes.time,
					};
				},
			},
			signedTextLabel: {
				default: null,
				parseHTML: element => element.getAttribute('data-signed-text-label'),
				renderHTML: attributes => {
					if (!attributes.signedTextLabel) {
						return {};
					}

					return {
						'data-signed-text-label': attributes.signedTextLabel,
					};
				},
			},
			dateLabel: {
				default: null,
				parseHTML: element => element.getAttribute('data-date-label'),
				renderHTML: attributes => {
					if (!attributes.dateLabel) {
						return {};
					}

					return {
						'data-date-label': attributes.dateLabel,
					};
				},
			},
			timeLabel: {
				default: null,
				parseHTML: element => element.getAttribute('data-time-label'),
				renderHTML: attributes => {
					if (!attributes.timeLabel) {
						return {};
					}

					return {
						'data-time-label': attributes.timeLabel,
					};
				},
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: `div[data-type="${this.name}"]`,
			},
		];
	},

	renderHTML({ node, HTMLAttributes }) {
		const { t } = this.options;
		if (!node?.attrs?.image) {
			return [
				'div',
				mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
					'data-type': this.name,
					style: 'border:none',
				}),
				[
					'div',
					{ class: 'proxyContainer' },
					[
						'div',
						[
							'p',
							`${node.attrs.signedTextLabel} ${node.attrs.medicalCredentials ?? node.attrs.username} ${t(
								'ON'
							)} ${node.attrs.date} ${t('AT')} ${node.attrs.time}`,
						],
					],
				],
			];
		}
		return [
			'div',
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				'data-type': this.name,
				style: 'border:none',
			}),
			[
				'div',
				{ class: 'proxyContainer' },
				['div', { style: 'margin-bottom:20px' }, ['img', { src: node.attrs.image, width: '90px' }]],
				[
					'div',
					[
						'p',
						`${node.attrs.signedTextLabel} ${node.attrs.medicalCredentials ?? node.attrs.username} ${t(
							'ON'
						)} ${node.attrs.date} ${t('AT')} ${node.attrs.time}`,
					],
				],
			],
		];
	},
});

export default ProxySignature;
